import React, {useState, useEffect} from 'react'

export default function Pagination() {

    const [data, setData] = useState([]);

    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(2);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);

    const pages = [];
    for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
      pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));

        console.log(currentItems, currentPage);

    }

    const renderPageNumbers = pages.map((number)=> {
        if(number < maxPageNumberLimit+1 && number > minPageNumberLimit){
            return <li key={number} id={number} className={currentPage ==  number ? "active" : null} onClick={handleClick}>{number}</li>
        }else{
            return null;
        }
    })

    useEffect(() => {
      fetch("https://jsonplaceholder.typicode.com/todos")
        .then((response) => response.json())
        .then((json) => setData(json));
    }, []);

    const renderData = (data) => {
        return (
            <ul>
              {data.map((todo, index) => {
                return <li key={index}>{todo.title}</li>;
              })}
            </ul>
          );
    }
    

    const handlePreviousClick = () => {
        setcurrentPage(currentPage - 1);
        console.log(currentItems, currentPage);

        if( (currentPage - 1) % pageNumberLimit == 0 ){
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    }
    
    const handleNextClick = () => {
        setcurrentPage(currentPage + 1);

        console.log(currentItems, currentPage);

        if(currentPage+1 > maxPageNumberLimit){
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    }


    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
      pageIncrementBtn = <li onClick={handleNextClick}> &hellip; </li>;
    }
  
    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
      pageDecrementBtn = <li onClick={handlePreviousClick}> &hellip; </li>;
    }

  return (
    <>
    <div>Pagination</div>

    <ul className='pageNumbers'>
            <li onClick={handlePreviousClick} disabled={currentPage == pages[0] ? true : false}>Prev</li>
            
            {pageDecrementBtn}
            {renderPageNumbers}
            {pageIncrementBtn}

            
            <li onClick={handleNextClick} disabled={currentPage == pages[pages.length - 1] ? true : false}>Next</li>
        </ul>


    {renderData(currentItems)}

    </>
  )
}
